export function getConta() {
  return localStorage.idconta
}
